module.exports = __webpack_public_path__ + "static/media/student-smart.de9c4a5e.svg";